import { EventTracking, EventType } from '@app/tracking';
export default {
    mounted(el, binding) {
        const eventType = binding.arg || 'click';
        el.addEventListener(eventType, event => {
            EventTracking.dispatch(EventType.Track, {
                category: (binding.value ? binding.value.category : null) || el.getAttribute('data-ga-category') || '',
                action: (binding.value ? binding.value.action : null) || el.getAttribute('data-ga-action') || eventType,
                label: (binding.value ? binding.value.label : null) || el.getAttribute('data-ga-label') || (el.innerHTML ? el.innerHTML.trim() : ''),
                value: (binding.value ? binding.value.value : null) || el.getAttribute('data-ga-value') || null,
            });
        });
    }
};
